module.exports = __webpack_public_path__ + "img/Proofsheet - Blue.29bedc71.png";